// extracted by mini-css-extract-plugin
export default {"Arrow":"Slick_Arrow__lIwkh","Arrow--Hidden":"Slick_Arrow--Hidden__4Ak97","carouselContainer":"Slick_carouselContainer__l6BmZ"};